export default __webpack_public_path__ + "static/media/upload-icon.0d1986e3.svg";